// Worker columns the skills matrix should not offer at all, from the build env:
//   REACT_APP_MATRIX_HIDDEN_COLUMNS=skillsCoverage,skillScore
// try.wilya.com hides the coverage % and skill score for every demo company;
// production builds leave the variable unset and show everything.
export const HIDDEN_MATRIX_COLUMNS: string[] = (
	process.env.REACT_APP_MATRIX_HIDDEN_COLUMNS ?? ""
)
	.split(",")
	.map((field) => field.trim())
	.filter(Boolean);

export const visibleMatrixColumns = (fields: string[]): string[] =>
	fields.filter((field) => !HIDDEN_MATRIX_COLUMNS.includes(field));
